// TODO: simplify this

export const popupsCollection = {
  popups: new Map<number, unknown>(),
  get size() {
    return this.popups.size;
  },
  get top() {
    return this.popups.get(this.size);
  },

  delete(index: number) {
    this.popups.delete(index);
    return this.size;
  },

  add(popup: unknown) {
    const index = this.size + 1;
    this.popups.set(index, popup);
    return index;
  },
};
